



<template>
  <div class="min-h-screen flex flex-col">
    <!-- Top Navigation Bar -->
    <header class="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-10">
        <Header></Header>
    </header>

    <!-- Main Content -->
    <main class="flex-grow container mx-auto px-4 py-12">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-full mx-auto">
                <!-- Right Card - Table -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow">
          <div class="p-4 border-b border-gray-200 flex items-center justify-between">
            <h3 class="text-lg font-semibold text-gray-900">Urządzenia</h3>
            <Button variant="outline">
              
              <a href="/add" class="flex items-center justify-center">
                Dodaj urządzenie
                <Plus class="w-4 h-4" />
              </a>
            </Button>
          </div>
          <div class="p-4 overflow-x-auto">
            <DataTable :currentRow="currentRowID as string" :columns="columns" :data="tableData" @rowClick="onRowClicked"></DataTable>
          </div>
        </div>
        <!-- Left Card - Leaflet Map -->
        <div class="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow">
          <div class="p-4 border-b border-gray-200 items-center justify-between flex">
            <h3 class="text-lg font-semibold text-gray-900">Mapa</h3>
            
          </div>
          <div class="p-0">
            <ClientOnly>
              <Map :currentDevice="currentDevice as Device" :devices="tableData" @markerClick="onRowClicked"></Map>
            </ClientOnly>
          </div>
        </div>
        

      </div>
    </main>

    <!-- Footer -->
    <footer class="bg-gray-50 border-t border-gray-200">
        <Footer></Footer>
    </footer>
  </div>
</template>

<script setup lang="ts">

import { ref, onMounted } from 'vue';
import { LocateFixedIcon, Plus } from 'lucide-vue-next'
import { columns } from './../components/devices/columns';
import { Footer, Header } from '#components';
import DataTable from '~/components/ui/datatable/data-table.vue';
import { useDeviceStore } from './../stores/devices';

let map = null;
const devices = useDeviceStore()
const tableData = ref<Device[]>([]);
let currentDevice = ref<Device>();
let currentRowID = ref<string>();

definePageMeta({
  middleware: 'auth'
})


function onRowClicked(device: Device) {
  currentDevice.value = device;
  currentRowID.value = device.id;
}


onMounted(async() => {
  let devicesData   = await useDeviceStore().getDevices() as Device[];
  tableData.value = devicesData;
});

</script>

<style>

</style>